import React from 'react'

const Footer = () => {
  return (
    <p style ={{color :"white ",
                   textAlign : 'center' ,}}>@ Created by{" "}
      
                   Akash Kumar Sadangi</p>
  )
}

export default Footer